/* Presentation only: checkout discounts remain governed by Bundler. */
(function(root){
  function allowed(items){
    if(items.length<2)return false;
    return items.every(item=>{
      if(!Number.isFinite(item.price)||item.price<=0)return false;
      if(item.extraDiscount || Number(item.compare)>item.price)return false;
      try{
        const control=JSON.parse(item.control||'null');
        if(!control)return true;
        if(control.version!==1||!Array.isArray(control.paused_groups))return false;
        // Conservative: a paused combo suppresses the extra claim for its pieces,
        // even when they also belong to another combo.
        return control.paused_groups.length===0;
      }catch{return false}
    });
  }
  function fromCard(card,selector){
    const option=card.querySelector(selector)?.selectedOptions[0];
    return {price:Number(option?.dataset.price),compare:Number(option?.dataset.compare||0),control:card.dataset.comboControl,extraDiscount:card.dataset.extraDiscount==='true'};
  }
  const api={allowed,fromCard};
  root.DaljiComboPolicy=api;
  if(typeof module!=='undefined'&&module.exports)module.exports=api;
})(typeof window!=='undefined'?window:globalThis);
